import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import HashLink from '../HashLink';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white shadow-sm">
      <div className="h-16 max-w-[1800px] mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <img 
            src="/logo.png" 
            alt="DeltaOps Logo" 
            className="h-10 w-auto"
          />
        </Link>

        {/* Mobile Menu Button */}
        <button 
          className="lg:hidden p-2 text-gray-600 hover:text-gray-900"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center space-x-8">
          <HashLink to="#demo" className="text-gray-600 hover:text-gray-900">Demo</HashLink>
          <HashLink to="#setup" className="text-gray-600 hover:text-gray-900">Quick Setup</HashLink>
          <HashLink to="#faq" className="text-gray-600 hover:text-gray-900">FAQ</HashLink>
          <HashLink to="#savings" className="text-gray-600 hover:text-gray-900">Savings Calculator</HashLink>
          <Link to="/pricing" className="text-gray-600 hover:text-gray-900">Pricing</Link>
          <Link to="/docs" className="text-gray-600 hover:text-gray-900">Docs</Link>
          <Button 
            variant="outline" 
            onClick={() => window.location.href = 'https://console.deltaops.app/login'}
          >
            Login
          </Button>
          <Button 
            onClick={() => window.location.href = 'https://console.deltaops.app/signup'}
          >
            Get Started
          </Button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`lg:hidden ${isMenuOpen ? 'block' : 'hidden'} border-t border-gray-200`}>
        <div className="px-4 py-2 space-y-3 bg-white">
          <HashLink 
            to="#demo" 
            className="block py-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsMenuOpen(false)}
          >
            Demo
          </HashLink>
          <HashLink 
            to="#setup" 
            className="block py-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsMenuOpen(false)}
          >
            Quick Setup
          </HashLink>
          <HashLink 
            to="#faq" 
            className="block py-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsMenuOpen(false)}
          >
            FAQ
          </HashLink>
          <HashLink 
            to="#savings" 
            className="block py-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsMenuOpen(false)}
          >
            Savings Calculator
          </HashLink>
          <Link 
            to="/pricing" 
            className="block py-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsMenuOpen(false)}
          >
            Pricing
          </Link>
          <Link 
            to="/docs" 
            className="block py-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsMenuOpen(false)}
          >
            Docs
          </Link>
          <div className="pt-2 space-y-2">
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => window.location.href = 'https://console.deltaops.app/login'}
            >
              Login
            </Button>
            <Button 
              className="w-full"
              onClick={() => window.location.href = 'https://console.deltaops.app/signup'}
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;